const configDeclaration = {
    board: {
        listLayout: 'DeclarationListDefaultLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',
        getFunc: 'getDeclaration',
        listApiParamSet: {
            ip:1
        },
        pageRow: 10,
        paginationType: 'pagination',
        deleteFunc: 'deleteDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'bb_idx',
        detailKey:''
    },
    message: {
        listLayout: 'DeclarationListMessageLayout',
        filterLayout: 'DeclarationFilterMessageLayout',
        paginationLayout: 'PaginationtNoDeleteLayout',

        getFunc: 'getDeclaration',
        listApiParamSet: {
            ip:1
        },
        deleteFunc: 'deleteDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'bb_idx',
        detailKey:''
    },
}

export default {
    methods: {
        returnDeclarationConfig(type) {
            return configDeclaration[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        wni: {
            type: 'query',
            classname: 'searchInput',
        },
        dni: {
            type: 'query',
            classname: 'searchInput',
        },
        wmid: {
            type: 'query',
            classname: 'searchInput',
        },
        bty:{
            type: 'match',
            classname: 'searchOption',
        }
    }
}
